import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import { useNavigate, useLocation } from "react-router-dom";

const MOB_MachineProduceInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [selectProjectID, setSelectProjectID] = useState('');
    const [selectProjectProductName, setSelectProjectProductName] = useState('');
    const [selectBomID, setSelectBomID] = useState('');
    const [selectBomItemName, setSelectBomItemName] = useState('');
    const [selectBomItemCount, setSelectBomItemCount] = useState(0);
    const [projectOption, setProjectOption] = useState([]);
    const [projectRows, setProjectRows] = useState([]);
    const [bomOption, setBomOption] = useState([]);
    const [bomRows, setBomRows] = useState([]);
    const [bomInputRows, setBomInputRows] = useState([]);

    useEffect(() => {
        appStore.setLoading(true);
        
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
        appStore.setLoading(false);
    }, []);

    useEffect(() => {
        if(selectProjectID === '' || selectProjectID === 0){
            setSelectProjectProductName('');
            setSelectBomID('');
            setSelectBomItemName('');
            setSelectBomItemCount(0);
        }else{
            var tmpProjectRows = projectRows.filter((data) => String(data.machine_project_id) === String(selectProjectID));
            if(tmpProjectRows.length > 0){
                setSelectProjectProductName(tmpProjectRows[0].product_name);
                setSelectBomID(tmpProjectRows[0].bom_id);
                setSelectBomItemName(tmpProjectRows[0].item_name);
                setSelectBomItemCount(Number(tmpProjectRows[0].item_count));
            }else{
                setSelectProjectProductName('');
                setSelectBomID('');
                setSelectBomItemName('');
                setSelectBomItemCount(0);
            }
        }
        
    }, [selectProjectID]);

    
    useEffect(() => {
        if(selectBomID === '' || selectBomID === '0'){
            setSelectBomItemName('');
            setSelectBomItemCount(0);
            setBomInputRows([]);
        }else{
            if(selectProjectID === '' || selectProjectID === '0'){
                alert('프로젝트 선택 후 BOM을 해야합니다.');
                setSelectBomID('');
            }else{
                var tmpBomRows = bomRows.filter((data) => String(data.bom_id) === String(selectBomID));
                if(tmpBomRows.length > 0){
                    const displayArray = tmpBomRows.map((item, index) => ({ 
                        input_item_id: item.input_item_id, 
                        input_item_name: item.input_item_name, 
                        input_item_count: item.input_item_count, 
                        input_item_spec: item.input_item_spec
                    }));
                    setSelectBomItemName(tmpBomRows[0].item_name);
                    setSelectBomItemCount(tmpBomRows[0].item_count);
                    setBomInputRows([ ...new Set((displayArray).map(JSON.stringify)) ].map(JSON.parse));
                }else{
                    setSelectBomItemName('');
                    setSelectBomItemCount(0);
                    setBomInputRows([]);
                }
            }
        }
        
    }, [selectBomID]);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 권한체크가 되면 MenuID가 변경되므로, 권한체크 후 Grid 설정.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleInitSelect();
        }
    }, [MenuID])
    
    const handleInitSelect = () => {
        axios.get('/api/p/MachineProduce/Select')
        .then((response) => {
            const optionArray = response.data.map((item, index) => 
                ({ value: item.machine_project_id, label: item.project_name + (item.product_name === '' || typeof item.product_name === 'undefined'?'':' / '+item.product_name) })
            );
            optionArray.unshift({ value: 0, label : '프로젝트 / 제품명'});
            setProjectOption([ ...new Set((optionArray).map(JSON.stringify)) ].map(JSON.parse));
            
            const array = response.data.map((item, index) => ({
                machine_project_id: item.machine_project_id,
                project_number: item.project_number,
                project_name: item.project_name,
                product_name: (typeof item.product_name === 'undefined'? "":String(item.product_name)),
                bom_id: (typeof item.bom_id === 'undefined'? "":String(item.bom_id)),
                bom_name: (typeof item.bom_name === 'undefined'? "":String(item.bom_name)),
                item_id: (typeof item.item_id === 'undefined'? "":String(item.item_id)),
                item_name: (typeof item.item_name === 'undefined'? "":String(item.item_name)),
                item_type_name: item.item_type_name,
                item_division_name: item.item_division_name,
                item_count: (typeof item.item_count === 'undefined'? "0":String(item.item_count)),
                item_spec: item.item_spec,
                item_width: item.item_width,
                item_height: item.item_height,
                item_depth: item.item_depth
            }));
            setProjectRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            console.log(error);
        });

        axios.get('/api/p/MachineProduce/BomList')
        .then((response) => {
            const optionArray = response.data.map((item, index) => 
                ({ value: item.bom_id, label: item.bom_name + (item.item_name === '' || typeof item.item_name === 'undefined'?'':' / '+item.item_name)+(item.item_count === '' || typeof item.item_count === 'undefined'?'':' / '+item.item_count) })
            );
            optionArray.unshift({ value: 0, label : 'BOM / 생산품목명 / 수량'});
            setBomOption([ ...new Set((optionArray).map(JSON.stringify)) ].map(JSON.parse));

            const array = response.data.map((item, index) => ({
                bom_id: item.bom_id,
                bom_name: item.bom_name,
                item_id: item.item_id,
                item_name: (typeof item.item_name === 'undefined'? "":String(item.item_name)),
                item_type_name: (typeof item.item_type_name === 'undefined'? "":String(item.item_type_name)),
                item_division_name: (typeof item.item_division_name === 'undefined'? "":String(item.item_division_name)),
                item_count: (typeof item.item_count === 'undefined'? "0":String(item.item_count)),
                item_spec: (typeof item.item_spec === 'undefined'? "":String(item.item_spec)),
                item_width: (typeof item.item_width === 'undefined'? "":String(item.item_width)),
                item_height: (typeof item.item_height === 'undefined'? "":String(item.item_height)),
                item_depth: (typeof item.item_depth === 'undefined'? "":String(item.item_depth)),
                input_item_id: (typeof item.input_item_id === 'undefined'? "":String(item.input_item_id)),
                input_item_name: (typeof item.input_item_name === 'undefined'? "":String(item.input_item_name)),
                input_item_type_name: (typeof item.input_item_type_name === 'undefined'? "":String(item.input_item_type_name)),
                input_item_division_name: (typeof item.input_item_division_name === 'undefined'? "":String(item.input_item_division_name)),
                input_item_count: (typeof item.input_item_count === 'undefined'? "":String(item.input_item_count)),
                input_item_spec: (typeof item.input_item_spec === 'undefined'? "":String(item.input_item_spec)),
                input_item_width: (typeof item.input_item_width === 'undefined'? "":String(item.input_item_width)),
                input_item_height: (typeof item.input_item_height === 'undefined'? "":String(item.input_item_height)),
                input_item_depth: (typeof item.input_item_depth === 'undefined'? "":String(item.input_item_depth))
                
            }));
            setBomRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            console.log(error);
        });
    };

    const handleSave = () => {
        if(selectProjectID === '' || selectProjectID === 0){
            alert('프로젝트가 선택되지 않았습니다.');
        }else if(selectProjectProductName === ''){
            alert('프로젝트 제품명이 입력되지 않았습니다.');
        }else if(selectBomID === '' || selectBomID === 0){
            alert('BOM이 선택되지 않았습니다.');
        }else{
            if (appStore.loading) return;
            appStore.setLoading(true);

            axios.post("/api/p/MachineProduce/Update", new URLSearchParams({
                machine_project_id: selectProjectID,
                product_name: selectProjectProductName,
                bom_id: selectBomID
             }),
             { withCredentials: true })
            .then(function (response) {
                if(response.status === 200){
                    alert('정상적으로 저장되었습니다.');
                    handleInitSelect();
                }
            })
            .catch(function (error) {
            })
            .finally(() => {
                appStore.setLoading(false); 
            });
        }
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="M_menubox" style={ { height: '50px' } }>
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div style={ { float: 'right' } }>
                        <Button 
                            onClick={handleSave}
                            className="M_btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#FF3636", 
                                backgroundColor: "#FF3636",
                                ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                            }} 
                            variant="outlined">
                            저장
                        </Button>
                    </div>
                </div>
            </div>
            
            <div className="M_contents">
                <div className="M_menu-keyword-sub-keyword">
                    <select placeholder="프로젝트" value={selectProjectID} onChange={(e) => setSelectProjectID(e.target.value) }>
                        {projectOption.map((item) => (
                            <option value={item.value}>{item.label}</option>
                        ))}
                    </select>
                </div>
                <div className="M_menu-keyword-sub-keyword">
                    <input type="text" placeholder="프로젝트 제품명" value={selectProjectProductName} onChange={(e) => setSelectProjectProductName(e.target.value) } style={{ width: '100%' }} />
                </div>
                
                <div className="M_menu-keyword-sub-keyword">
                    <select placeholder="BOM" value={selectBomID} onChange={(e) => setSelectBomID(e.target.value) }>
                        {bomOption.map((item) => (
                            <option value={item.value}>{item.label}</option>
                        ))}
                    </select>
                </div>
                <div style={ { display: 'block' } }>
                    <p style={ { fontSize: '20px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' } }>BOM 사용 품목</p>
                </div>
                <div style={ { display: 'block' } }>
                    {bomInputRows.map((item) => (
                        <div style={ { paddingBottom: '5px' } }>
                            <span>{ item.input_item_name }  { item.input_item_spec}</span>
                            <span style={ { float: 'right' } }>{ item.input_item_count }</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default MOB_MachineProduceInfo;